export enum StorageTypes {
  Api = 'api',
  Local = 'local',
}
